<template>
  <div>
    <!-- CREATE MODAL -->
    <b-modal id="modal-sklad" title="Cклад" hide-footer size="lg"
      @shown="Shovedform" @hidden="Hidecreate()"
      modal-class="modern-modal">
      <div class="modal-form">
        <div class="form-unit">
          <label>{{ $t("Номи") }}</label>
          <input class="form-input" ref="inputText1" v-model="skladnew.name" type="text" :placeholder="$t('Kiriting...')" />
        </div>
        <div class="form-unit">
          <label>Телефон</label>
          <input class="form-input" v-model="skladnew.phone_number" type="text" />
        </div>
        <div class="form-unit">
          <label>{{ $t("Манзил") }}</label>
          <input class="form-input" v-model="skladnew.address" type="text" />
        </div>
        <div class="form-unit">
          <label>{{ $t("Чек ёзуви") }}</label>
          <input class="form-input" v-model="skladnew.check_word" type="text" />
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save" @click="Createsklad()">
            <b-icon icon="check-all" class="mr-1"></b-icon> {{ $t("Сақлаш") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- UPDATE MODAL -->
    <b-modal id="modal-skladset" title="Cклад" hide-footer size="lg"
      @shown="Shovedform" @hidden="Hidecreate()"
      modal-class="modern-modal">
      <div class="modal-form">
        <div class="form-unit">
          <label>{{ $t("Номи") }}</label>
          <input class="form-input" ref="inputText1" v-model="sklad.name" type="text" />
        </div>
        <div class="form-unit">
          <label>Телефон</label>
          <input class="form-input" v-model="sklad.phone_number" type="text" />
        </div>
        <div class="form-unit">
          <label>{{ $t("Манзил") }}</label>
          <input class="form-input" v-model="sklad.address" type="text" />
        </div>
        <div class="form-unit">
          <label>{{ $t("Чек ёзуви") }}</label>
          <input class="form-input" v-model="sklad.check_word" type="text" />
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save" @click="Updatesklad()">
            <b-icon icon="check-all" class="mr-1"></b-icon> {{ $t("Сақлаш") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- LIST MODAL -->
    <b-modal id="modal-skladlist" title="Склад" hide-footer size="xl"
      @shown="Shoved" @hidden="Hide()"
      modal-class="modern-modal">
      <div class="modal-list">
        <div class="modal-list-header">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input type="text" class="modern-search" :placeholder="$t('Қидирув...')" v-model="filter" ref="inputText1" />
          </div>
          <button type="button" class="add-btn" v-b-modal.modal-sklad>
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}
          </button>
        </div>

        <div class="modal-table-wrapper">
          <table class="modal-table">
            <thead>
              <tr>
                <th style="width:60px">#</th>
                <th>Номи</th>
                <th style="width:120px;text-align:center">{{ $t("Amallar") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredRows" :key="index"
                @click="datas.sklad_id = item.id; $bvModal.hide('modal-skladlist');" class="clickable-row">
                <td><span class="id-badge">{{ index + 1 }}</span></td>
                <td class="font-bold">{{ item.name }}</td>
                <td @click.stop>
                  <div class="actions">
                    <button type="button" class="icon-btn edit"
                      @click="sklad = filteredRows[index]; sett = index;" v-b-modal.modal-skladset>
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button type="button" class="icon-btn del" @click="Skladtrash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="filteredRows.length === 0">
                <td colspan="3" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "sklad",
  data() {
    return {
      focusset: "",
      sklad: {
        name: "",
        phone_number: "+998",
        address: "",
        check_word: ""
      },
      skladnew: {
        name: "",
        phone_number: "+998",
        address: "",
        check_word: ""
      },
      skladlist: [],
      filter: "",
      sett: null
    };
  },
  props: ["datas"],
  computed: {
    filteredRows() {
      return this.skladlist.filter(row => {
        const name = row.name.toString().toLowerCase();
        const searchTerm = this.filter.toLowerCase();
        return name.includes(searchTerm);
      });
    }
  },
  methods: {
    Skladtrash(id) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        let self = this;
        axios({
          method: "delete",
          url: "api/v1/sklads/id/" + id
        }).then(function(response) {
          self.Skladlist();
        });
      }
    },
    Skladlist() {
      let self = this;
      axios.get("api/v1/sklads").then(function(response) {
        self.skladlist = response.data;
        self.$root.$emit("skladall", response.data);
      });
    },
    Updatesklad() {
      let self = this;
      axios({
        method: "patch",
        url: "api/v1/sklads/id/" + self.sklad.id,
        data: self.sklad
      }).then(function(response) {
        self.Skladlist();
        self.sklad = {
          name: "",
          phone_number: "+998",
          address: "",
          check_word: ""
        };
        self.$store.state.saved_modal = "updated";
        self.$bvModal.hide("modal-skladset");
        self.sklad = {
          name: "",
          phone_number: "+998",
          address: "",
          check_word: ""
        };
      });
    },
    Shovedform() {
      this.$bvModal.hide("modal-skladlist");
      if (this.$store.state.saved_modal == "update") {
        this.$store.state.saved_modal = null;
      }
      let self = this;
      $(document).on("focusout", function(e) {
        if ($(e.target).attr("class") == "vs__search") {
          if (self.focusset == "") {
            self.focusset = e.target;
          }
        }
      });
      self.$refs.inputText1.focus();
    },
    Shoved() {
      let self = this;
      $(document).on("focusout", function(e) {
        if ($(e.target).attr("class") == "vs__search") {
          if (self.focusset == "") {
            self.focusset = e.target;
          }
        }
      });
      if (self.sett == "create") {
        var set = document.getElementsByClassName("atable");
        set[set.length - 1].focus();
      } else if (self.sett == null) {
        self.$refs.inputText1.focus();
      } else if (self.sett >= 0) {
        var set = document.getElementsByClassName("atable");
        set[self.sett].focus();
      } else {
        self.$refs.inputText1.focus();
      }
    },
    Hide() {
      let self = this;
      setTimeout(function(e) {
        var classs = $(":focus");
        var rrr = $("body")
          .find("input,select,textarea,button")
          .filter(":visible");

        if (classs.attr("class") == "modallist") {
          if (
            $(self.focusset)
              .siblings(".vs__selected")
              .attr("class") != undefined
          ) {
            var focused = rrr.eq(rrr.index(classs) + 1);
            focused.focus();
          } else {
            $(self.focusset).focus();
          }
        } else if (classs.attr("class") == undefined) {
          if (
            $(self.focusset)
              .siblings(".vs__selected")
              .attr("class") != undefined
          ) {
            focused = rrr.eq(rrr.index($(self.focusset)) + 2);
            focused.focus();
          } else {
            $(self.focusset).focus();
          }
        } else if (classs.attr("class") == "modal-content") {
          self.$refs.inputText1.focus();
        }
      }, 100);
    },
    Createsklad() {
      let self = this;
      self.$bvModal.hide("modal-skladlist");
      axios({
        method: "post",
        url: "api/v1/sklads",
        data: self.skladnew
      }).then(function(response) {
        self.$bvModal.hide("modal-sklad");
        self.skladlist.push(response.data);
        self.$store.state.saved_modal = "created";
        self.sett = "create";
        self.skladnew = {
          name: "",
          phone_number: "+998",
          address: "",
          check_word: ""
        };
        self.$root.$emit("skladone", self.skladnew);
      });
    },
    Hidecreate() {
      if (this.$store.state.saved_modal == "create") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Createsklad();
        } else {
          this.skladnew = {
            name: "",
            phone_number: "+998",
            address: "",
            check_word: ""
          };
          this.$root.$emit("skladone", this.skladnew);
        }
      } else if (this.$store.state.saved_modal == "update") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Updatesklad();
        }
      }
      this.$store.state.saved_modal = null;
      this.$bvModal.show("modal-skladlist");
    }
  },
  watch: {
    sklad: {
      deep: true,
      handler(val, oldVal) {
        if (this.$store.state.saved_modal == null) {
          this.$store.state.saved_modal = "update";
        }
      }
    },
    skladnew: {
      deep: true,
      handler(val, oldVal) {
        if (val.name != "") {
          this.$store.state.saved_modal = "create";
        } else {
          this.$store.state.saved_modal = null;
        }
      }
    }
  },
  created: function() {
    this.$root.$emit("skladone", this.skladnew);
    this.Skladlist();
  }
};
</script>
<style scoped>
/* MODAL FORM */
.modal-form {
  padding: 10px;
}

.form-unit {
  margin-bottom: 20px;
}

.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 15px;
  border-top: 1px solid #f1f2f6;
}

.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

/* LIST MODAL */
.modal-list {
  padding: 5px;
}

.modal-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 10px 15px 10px 38px;
  border-radius: 12px;
  width: 100%;
  outline: none;
  transition: 0.3s;
  font-weight: 500;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
  background: white;
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 42px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  white-space: nowrap;
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

/* TABLE */
.modal-table-wrapper {
  max-height: 60vh;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
}

.modal-table {
  width: 100%;
  border-collapse: collapse;
}

.modal-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.modal-table th {
  background: #f8fafc;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f2f6;
}

.modal-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  font-size: 14px;
  color: #334155;
  vertical-align: middle;
}

.clickable-row {
  cursor: pointer;
  transition: 0.15s;
}

.clickable-row:hover {
  background: #faf8ff;
}

.id-badge {
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.font-bold {
  font-weight: 700;
}

/* ACTIONS */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.empty-row {
  text-align: center;
  padding: 40px !important;
  color: #94a3b8;
  font-style: italic;
}
</style>
